<template>
  <main>
    <div class="d-flex flex-column flex-shrink-0 p-3 text-white bg-dark position-relative mianBox" style="width: 250px"
         :class="{'shrink':shrink}">
      <div class="text-white text-decoration-none text-center listBox">
        <span class="fs-5 fw-bold" v-show="!shrink">云呼叫系统</span>
      </div>
      <div class="menuBox canCLick" @click="shrink=!shrink">
        <img :src="listIcon" alt="" width="20" height="20"/>
      </div>
      <hr/>
      <ul class="nav nav-pills flex-column mb-auto">
        <li class="nav-item" v-for="(menu, menuId) in menuList" :key="menuId"
            :class="{ active: menuId == activeMenuId }" @click="activeMenuId = menuId">
          <a href="#" class="nav-link d-flex align-items-center text-white" aria-current="page">
            <i :class="{ [menu.icon]: true }"></i>
            <div v-show="!shrink" class="px-2 fw-bold">{{ menu.title }}</div>
          </a>
        </li>
      </ul>
    </div>

    <div class="w-100 rightContainer">
      <div class="topBox d-flex justify-content-between align-items-center px-3">
        <div class="d-flex justify-content-between align-items-center">
          <BaseDropdown @clickItem="changeStatus" :disibled="!showDropdown">
            <div class="statusContent" :style="{backgroundColor: statusObject[status].color}">
              <span>{{ statusObject[status].text }}</span>
              <img :src="downTri" width="12" height="12"/>
              <span> | </span>
              <span>{{ timers.callTimerStr }}</span>
            </div>
            <template #dropdownList>
              <div v-show="showDropdown">
                <li v-show="status !== 'READY'" class="dropdown-item canCLick" @click="changeStatus('READY')">空闲</li>
                <li v-show="status!=='NOT_READY'" class="dropdown-item canCLick" @click="changeStatus('NOT_READY')">忙碌
                </li>
              </div>
            </template>
          </BaseDropdown>

          <BaseDropdownTel v-show="showBtn('phoneOutcall')" ref="dropdownTel">
            <BaseHoverDown>
              <div class="iconBox canCLick">
                <img :src="phoneOutcall" width="20" height="20"/>
              </div>
              <template #toast>
                <span>外呼</span>
              </template>
            </BaseHoverDown>

            <template #list>
              <input v-model="telNum" type="text" class="form-contro telNum" placeholder="请输入号码"/>
              <button class="btn btn-primary mx-1" :disabled="!telNum" @click.stop.prevent="callFun('MAKE_CALL')">
                呼叫
              </button>
            </template>
          </BaseDropdownTel>

          <BaseHoverDown v-show="showBtn('phoneAnswer')">
            <div class="iconBox canCLick" @click.stop.prevent="accept()">
              <img :src="phoneAnswer" width="20" height="20"/>
            </div>
            <template #toast>
              <span>应答</span>
            </template>
          </BaseHoverDown>

          <BaseHoverDown v-show="showBtn('phoneMute')">
            <div class="iconBox canCLick" @click.stop.prevent="callFun('MUTE')">
              <img :src="phoneMute" width="20" height="20"/>
            </div>
            <template #toast>
              <span>静音</span>
            </template>
          </BaseHoverDown>

          <BaseHoverDown v-show="showBtn('phoneCancelMute')">
            <div class="iconBox canCLick" @click.stop.prevent="callFun('MUTE_CANCEL')">
              <img :src="phoneCancelMute" width="20" height="20"/>
            </div>
            <template #toast>
              <span>取消静音</span>
            </template>
          </BaseHoverDown>

          <BaseHoverDown v-show="showBtn('phonehold')">
            <div class="iconBox canCLick" @click.stop.prevent="callFun('HOLD')">
              <img :src="phonehold" width="20" height="20"/>
            </div>
            <template #toast>
              <span>保持</span>
            </template>
          </BaseHoverDown>

          <BaseHoverDown v-show="showBtn('phoneCancelhold')">
            <div class="iconBox canCLick" @click.stop.prevent="callFun('HOLD_CANCEL')">
              <img :src="phoneCancelhold" width="20" height="20"/>
            </div>
            <template #toast>
              <span>取消保持</span>
            </template>
          </BaseHoverDown>

          <BaseDropdownTel v-show="showBtn('phoneTransfer')" ref="dropdownTransfer">
            <BaseHoverDown>
              <div class="iconBox canCLick">
                <img :src="phoneTransfer" width="20" height="20"/>
              </div>
              <template #toast>
                <span>转接</span>
              </template>
            </BaseHoverDown>

            <template #list>
              <input v-model="telNumTransfer" type="text" class="form-contro telNum" placeholder="请输入号码"/>
              <button class="btn btn-primary mx-1" :disabled="!telNumTransfer"
                      @click.stop.prevent="callFun('TRANSFER')">
                转接
              </button>
            </template>
          </BaseDropdownTel>

          <BaseHoverDown v-show="showBtn('phoneCancelTransfer')">
            <div class="iconBox canCLick" @click.stop.prevent="callFun('TRANSFER_CANCEL')">
              <img :src="phoneCancel" width="20" height="20"/>
            </div>
            <template #toast>
              <span>取消转接</span>
            </template>
          </BaseHoverDown>

          <BaseDropdownTel ref="dropdownConsult" v-show="showBtn('phoneConsult')">
            <BaseHoverDown>
              <div class="iconBox canCLick">
                <img :src="phoneConsult" width="20" height="20"/>
              </div>
              <template #toast>
                <span>咨询</span>
              </template>
            </BaseHoverDown>

            <template #list>
              <input v-model="telNumConsult" type="text" class="form-contro telNum" placeholder="请输入号码"/>
              <button class="btn btn-primary mx-1" :disabled="!telNumConsult" @click.stop.prevent="callFun('CONSULT')">
                咨询
              </button>
            </template>
          </BaseDropdownTel>

          <BaseHoverDown v-show="showBtn('phoneCancelConsult')">
            <div class="iconBox canCLick" @click.stop.prevent="callFun('CONSULT_CANCEL')">
              <img :src="phoneCancel" width="20" height="20"/>
            </div>
            <template #toast>
              <span v-if="status === 'CONSULT_TALKING' ||  status === 'CONSULT_IVR' ">结束咨询</span>
              <span v-else>取消咨询</span>
            </template>
          </BaseHoverDown>

          <BaseHoverDown v-show="showBtn('phoneConsultParty')">
            <div class="iconBox canCLick" @click.stop.prevent="callFun('CONSULT_PARTY')">
              <img :src="phoneParty" width="20" height="20"/>
            </div>
            <template #toast>
              <span>转多方</span>
            </template>
          </BaseHoverDown>

          <BaseHoverDown v-show="showBtn('phoneTransfer2')">
            <div class="iconBox canCLick" @click.stop.prevent="callFun('CONSULT_TRANSFER')">
              <img :src="phoneTransfer2" width="20" height="20"/>
            </div>
            <template #toast>
              <span>咨询转接</span>
            </template>
          </BaseHoverDown>

          <!--          <BaseDropdownTel v-show="showBtn('phoneTransfer2')" ref="dropdownTransfer">
                      <BaseHoverDown>
                        <div class="iconBox canCLick">
                          <img :src="phoneTransfer2" width="20" height="20" />
                        </div>
                        <template #toast>
                          <span>咨询转接</span>
                        </template>
                      </BaseHoverDown>

                      <template #list>
                        <input v-model="telNumTransfer" type="text" class="form-contro telNum" placeholder="请输入号码" />
                        <button class="btn btn-primary mx-1" :disabled="!telNumTransfer"
                          @click.stop.prevent="callFun('TRANSFER')">
                          咨询转接
                        </button>
                      </template>
                    </BaseDropdownTel>-->

          <BaseHoverDown v-show="showBtn('phoneHangup')">
            <div class="iconBox canCLick" @click.stop.prevent="callFun('HANGUP_CALL')">
              <img :src="phoneHangup" width="20" height="20"/>
            </div>
            <template #toast>
              <span>挂机</span>
            </template>
          </BaseHoverDown>
        </div>

        <div v-if="callDate.callType === 'INBOUND_CALL'">
          caller:{{ callDate.caller }}
          called:{{ callDate.callerDisplay }}
        </div>
        <div v-else-if="callDate.callType === 'OUTBOUND_CALL'">
          caller:{{ callDate.calledDisplay }}
          called:{{ callDate.called }}
        </div>
        <div v-else-if="callDate.callType === 'AUTO_OUTBOUND_CALL'">
          caller:{{ callDate.calledDisplay }}
          called:{{ callDate.called }}
        </div>

        <div class="dropdown-box">
          <BaseDropdown :dropList="logoutDropList" @clickItem="logoutFun" showTriangle>
            <div>
              <img :src="avatar" alt="" width="42" height="42" class="rounded-circle me-2"/>
            </div>
            <div>
              <div>
                <strong>{{ loginData.agentKey }}</strong>
              </div>
            </div>
          </BaseDropdown>
        </div>
      </div>
      <div v-if="!activeMenuId" class="fs-3">
        <CallLog ref="callLog" @itemClick="callLogItemClick"></CallLog>
        <CallDetail :activeCallId="activeCallId" ref="callDetail"></CallDetail>
      </div>
      <div v-else class="fs-3 contentBox">班长监控</div>
      <!-- 多方会议参会列表 -->
      <div class="partyContainer" v-if="conferenceList.length">
        <div class="conferenceList">
          <div class="partyItem" v-for="(item, index) in conferenceList" :key="index">
            <div class="d-flex justify-content-between">
              <div>{{ item.username }}</div>
              <div class="removeRoom" @click.stop.prevent="removeRoomFun(item)">移除会议</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audio id="peerVideo" autoplay></audio>
    <audio id="remoteVideo" autoplay>
    </audio>
    <audio id="incomingcallAudio" :src="audioRing" loop></audio>
  </main>
</template>

<script>
import avatar from '../assets/img/avatar.png'
import listIcon from '../assets/img/list.png'
import phoneOutcall from '../assets/img/phone-outcall.png'
import phoneHangup from '../assets/img/phone-hangup.png'
import phoneCancelhold from '../assets/img/phone-cancelhold.png'
import phonehold from '../assets/img/phone-hold.png'
import phoneAnswer from '../assets/img/phone-answer.png'
import phoneCancelMute from '../assets/img/phone-cancelmute.png'
import phoneMute from '../assets/img/phone-mute.png'
import phoneConsult from '../assets/img/phone-consult.png'
import phoneCancel from '../assets/img/phone-cancel.png'
import phoneTransfer from '../assets/img/phone-transfer.png'
import phoneTransfer2 from '../assets/img/phone-transfer2.png'
import phoneParty from '../assets/img/phone-party.png'

import downTri from '../assets/img/downTri.png'
import audioRing from '/static/beep.wav'
import Voice9 from 'voice9'

export default {
  name: 'ConnectingPage',
  props: {},
  data() {
    return {
      audioRing,
      loginData: {},
      voice9: null,
      manualLogout: false,

      conferenceList: [],

      statusObject: {
        LOGIN: {
          text: '已登录',
          color: '#0d6efd',
          showBtn: ['phoneOutcall']
        },
        LOGOUT: {
          text: '已退出',
          color: '#0d6efd',
          showBtn: []
        },
        READY: {
          text: '空闲',
          color: '#0d6efd',
          showBtn: ['phoneOutcall']
        },
        NOT_READY: {
          text: '忙碌',
          color: '#EA9738',
          showBtn: ['phoneOutcall']
        },
        AFTER: {
          text: '话后',
          color: '#0d6efd',
          showBtn: ['phoneOutcall']
        },
        OUT_CALL: {
          text: '外呼中',
          color: '#18bc9c',
          showBtn: ['phoneHangup']
        },
        OUT_CALLER_RING: {
          text: '外呼主叫振铃',
          color: '#18bc9c',
          showBtn: ['phoneAnswer', 'phoneHangup']
        },
        OUT_CALLED_RING: {
          text: '外呼被叫振铃',
          color: '#18bc9c',
          showBtn: ['phoneHangup']
        },
        PLAY_AGENT_ID: {
          text: '播放坐席工号',
          color: '#18bc9c',
          showBtn: ['phoneHangup']
        },
        TALKING: {
          text: '通话中',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phonehold', 'phoneMute', 'phoneTransfer', 'phoneConsult']
        },
        MUTE_TALKING: {
          text: '静音中',
          color: '#18bc9c',
          showBtn: ['phoneCancelMute']
        },
        HOLD_TALKING: {
          text: '保持',
          color: '#18bc9c',
          showBtn: ['phoneCancelhold']
        },
        INNER_CALL_RING: {
          text: '内呼来电振铃',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneAnswer']
        },
        INNER_CALL_TALKING: {
          text: '内呼通话中',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneMute']
        },
        INBOUND_RING: {
          text: '来电振铃',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneAnswer']
        },
        TRANSFER: {
          text: '转接中',
          color: '#18bc9c',
          showBtn: ['phoneCancelTransfer']
        },
        TRANSFERED_RING: {
          text: '转接来电振铃',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneAnswer']
        },
        TRANSFER_OUT_RING: {
          text: '转接外呼振铃',
          color: '#18bc9c',
          showBtn: ['phoneCancelTransfer']
        },
        TRANSFERED_TALKING: {
          text: '转接来电通话中',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneMute', 'phoneTransfer', 'phoneConsult']
        },
        CONSULT: {
          text: '咨询中',
          color: '#18bc9c',
          showBtn: ['phoneCancelConsult']
        },
        CONSULT_RING: {
          text: '咨询来电振铃',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneAnswer']
        },
        CONSULT_OUT_RING: {
          text: '咨询外呼振铃',
          color: '#18bc9c',
          showBtn: ['phoneCancelConsult']
        },
        CONSULT_IVR: {
          text: '咨询IVR',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneCancelConsult']
        },
        CONSULT_TALKING: {
          text: '咨询通话中',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneMute', 'phoneCancelConsult', 'phoneConsultParty', 'phoneTransfer2']
        },
        CONSULTED_TALKING: {
          text: '来电咨询中',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneMute']
        },
        CONFERENCE_TALKING: {
          text: '多方通话',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneMute', 'phoneConsult']
        },
        MONITOR_CALL: {
          text: '监控振铃',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneAnswer']
        },
        MONITOR_TALKING: {
          text: '监控通话中',
          color: '#18bc9c',
          showBtn: ['phoneHangup']
        },
        COACH_CALL: {
          text: '辅导振铃',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneAnswer']
        },
        COACH_TALKING: {
          text: '辅导通话中',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneMute']
        },
        INTERCEPT_TALKING: {
          text: '强拆通话中',
          color: '#18bc9c',
          showBtn: ['phoneHangup', 'phoneMute']
        }
      },
      status: 'LOGIN',
      lastStatus: 'LOGIN',

      logoutDropList: [{
        text: '登出',
        type: 'LOGOUT',
      },],

      menuList: [{
        title: '通话记录',
        icon: 'bi-telephone',
      },
        {
          title: '班长监控',
          icon: 'bi-megaphone',
        },
      ],
      activeMenuId: 0,

      avatar,
      listIcon,
      phoneOutcall,
      phoneHangup,
      phoneCancelhold,
      phonehold,
      phoneAnswer,
      phoneCancelMute,
      phoneMute,
      phoneConsult,
      phoneCancel,
      phoneTransfer,
      phoneTransfer2,
      phoneParty,

      downTri,

      timers: {
        callTimer: 0,
        callTimerStr: '00:00:00',
        callTimerInterval: null,
      },

      telNum: '',
      telNumTransfer: '',
      telNumConsult: '',
      shrink: false,

      activeCallId: null,

      callDate: {
        callType: '',
        caller: '',
        callerDisplay: '',
        called: '',
        calledDisplay: '',
      },

      notReconectStatus: [
        1403, //坐席在别处登录
        1105, //账号未登录
        1417, //坐席被强制下线
      ],
    }
  },
  components: {
    BaseDropdown: () => import('./base/Drowdown.vue'),
    BaseDropdownTel: () => import('./base/DrowDownTel.vue'),
    BaseHoverDown: () => import('./base/HoverDown.vue'),
    CallLog: () => import('./business/CallLog.vue'),
    CallDetail: () => import('./business/CallDetail.vue'),
  },
  created() {},
  mounted() {
    this.getLoginData()
    this.initSdk()
    this.timersFun()
  },
  computed: {
    showDropdown() {
      let canshow = ["LOGIN", "READY", "NOT_READY", "AFTER"]
      return canshow.includes(this.status)
    },
  },
  destroyed() {
    this.clearIntervalFun()
    this.manualLogout = true
    if (this.voice9) {
      this.voice9.logout()
    }
    this.voice9 = null
  },
  methods: {
    getLoginData() {
      this.loginData = sessionStorage.getItem('loginData') ?
          JSON.parse(sessionStorage.getItem('loginData')) : {}
    },
    initSdk() {
      if (!this.loginData.token) {
        return
      }
      this.voice9 = new Voice9()
      this.voice9.init(this.loginData)
      this.voice9.addEventListener('message', this.onMessage)
      this.voice9.addEventListener('logout', this.onLogout)
    },
    onMessage(data) {
      let type = data.type
      let statusEnum = this.statusObject[type]
      if (statusEnum === null || statusEnum === undefined) {
        return
      }
      this.lastStatus = this.status
      // 状态不为0时 改为上次的状态
      if (data.code !== 0) {
        this.status = this.lastStatus
      } else {
        this.status = type
      }
      this.timersFun()
      //根据状态处理函数
      this.statusChangeFun(data)

      // 错误给出提示信息
      if (data.code !== 0) {
        this.$toast.open({
          message: data.message,
          type: 'error',
          position: 'bottom',
        })
        if (this.notReconectStatus.includes(data.code)) {
          this.doLogout()
        }
        return
      }

      //显示主被叫号码
      if (data.data != null) {
        this.callDate.callType = data.data.callType
        this.callDate.caller = data.data.caller
        this.callDate.callerDisplay = data.data.callerDisplay
        this.callDate.called = data.data.called
        this.callDate.calledDisplay = data.data.calledDisplay
      }
    },
    onLogout(code) {
      this.clearIntervalFun()
      if (this.manualLogout) {
        this.manualLogout = false
        return
      }
      if (this.notReconectStatus.includes(code)) {
        this.voice9 = null
        this.$toast.open({
          message: '连接已断开，请重新登录',
          type: 'error',
          position: 'bottom',
        })
        this.doLogout()
      } else {
        // 连接断开，SDK会自动重连
        this.$toast.open({
          message: '连接已断开，正在尝试重新连接',
          type: 'error',
          position: 'bottom',
          duration: 5000,
        })
      }
    },
    statusChangeFun(data) {
      let {
        type,
      } = data
      let dataResponse = data.data

      // 转多方会议，参会人
      if (dataResponse && dataResponse.conferenceList) {
        this.conferenceList = dataResponse.conferenceList
      } else {
        this.conferenceList = []
      }

      if (type === 'AFTER') {
        // 话后
        // 手动拉通话log
        if (this.$refs.callLog) {
          this.$refs.callLog.init()
        }
        this.clearIntervalFun()
      }
    },
    // 应答
    accept() {
      if (this.voice9) {
        this.voice9.acceptCall()
      }
    },
    // 通话后修改状态
    changeStatus(type) {
      console.log("[" + dateStr() + "] changeStatus active type：" + type);
      if (this.voice9) {
        if (type === 'READY') {
          this.voice9.setReady()
        } else if (type === 'NOT_READY') {
          this.voice9.setNotReady()
        }
      }
    },
    callFun(type) {
      console.log("[" + dateStr() + "] callFun active type：", type);
      if (!this.voice9) {
        return
      }
      switch (type) {
        case 'MAKE_CALL':
          this.$refs.dropdownTel.closeItem();
          this.voice9.makeCall(this.telNum);
          break
        case 'TRANSFER':
          this.$refs.dropdownTransfer.closeItem()
          this.voice9.phoneTransfer(this.telNumTransfer);
          break
        case 'CONSULT':
          this.$refs.dropdownConsult.closeItem()
          this.voice9.phoneConsult(this.telNumConsult);
          break
        case 'CONSULT_CANCEL':
          // 如果是咨询中，调用结束咨询
          if (this.status === 'CONSULT_TALKING' || this.status === 'CONSULT_IVR') {
            this.voice9.phoneConsultStop()
          } else {
            this.voice9.phoneConsultCancel()
          }
          break
        case 'CONSULT_PARTY':
          this.voice9.phoneConsultParty();
          break
        case 'CONSULT_TRANSFER':
          this.voice9.phoneConsultTransfer(this.telNumTransfer);
          break
        case 'TRANSFER_CANCEL':
          // SDK未提供取消转接方法，走自定义消息
          this.voice9.customMessage(JSON.stringify({
            cmd: 'TRANSFER_CANCEL',
            agentKey: this.loginData.agentKey,
            sequence: new Date().getTime(),
          }))
          break
        case 'MUTE':
          this.voice9.mutePhone();
          break
        case 'MUTE_CANCEL':
          this.voice9.muteCancel();
          break
        case 'HOLD':
          this.voice9.holdTalking();
          break
        case 'HOLD_CANCEL':
          this.voice9.holdCancel();
          break
        case 'HANGUP_CALL':
          this.voice9.hangupCall();
          break
      }
    },
    removeRoomFun(item) {
      this.voice9.conferenceRemove(item)
    },
    showBtn(type) {
      return this.statusObject[this.status].showBtn.includes(type)
    },
    timersFun() {
      this.clearIntervalFun()
      this.timers.callTimerStr = '00:00:00'
      this.$nextTick(() => {
        this.timers.callTimerInterval = setInterval(() => {
          this.timers.callTimer++;
          this.timers.callTimerStr = this.formatSeconds(this.timers.callTimer);
        }, 1000);
      })
    },
    clearIntervalFun() {
      window.clearInterval(this.timers.callTimerInterval)
      this.timers.callTimer = 0
    },
    formatSeconds(seconds) {
      return [parseInt(seconds / 60 / 60), parseInt(seconds / 60 % 60), parseInt(seconds % 60)].join(":").replace(
          /\b(\d)\b/g, "0$1");
    },
    callLogItemClick(id) {
      this.activeCallId = id
    },
    logoutFun() {
      // 断开连接，退出登录
      this.manualLogout = true
      if (this.voice9) {
        this.voice9.logout()
      }
      this.$toast.open({
        message: '登出成功',
        type: 'success',
        position: 'bottom',
      })
      this.doLogout()
    },
    doLogout() {
      setTimeout(() => {
        sessionStorage.setItem('loginData', JSON.stringify({}))
        this.$emit('callbackFun', {})
      }, 1000)
    },
  },
}

function dateStr() {
  var date = new Date();
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  var d = date.getDate();
  var h = date.getHours();
  var mm = date.getMinutes();
  var s = date.getSeconds();
  var sss = date.getMilliseconds();
  if (m < 10) {
    m = "0" + m;
  }
  if (d < 10) {
    d = "0" + d;
  }
  if (h < 10) {
    h = "0" + h;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  if (s < 10) {
    s = "0" + s;
  }
  if (sss < 10) {
    sss = sss + "00";
  } else if (sss < 100) {
    sss = sss + "0";
  }
  return y + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s + "." + sss;
}
</script>

<style scoped>
main {
  display: flex;
  width: 100%;
  height: 100vh;
  height: -webkit-fill-available;
  max-height: 100vh;
  flex-wrap: nowrap;
  overflow: hidden;
}

.listBox {
  height: 35px;
}

.bi {
  vertical-align: -0.125em;
  pointer-events: none;
  fill: currentColor;
}

.dropdown-toggle {
  outline: 0;
}

.nav-flush .nav-link {
  border-radius: 0;
}

.btn-toggle {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
  background-color: transparent;
  border: 0;
}

.btn-toggle:hover,
.btn-toggle:focus {
  color: rgba(0, 0, 0, 0.85);
  background-color: #d2f4ea;
}

.btn-toggle::before {
  width: 1.25em;
  line-height: 0;
  content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
  transition: transform 0.35s ease;
  transform-origin: 0.5em 50%;
}

.btn-toggle[aria-expanded='true'] {
  color: rgba(0, 0, 0, 0.85);
}

.btn-toggle[aria-expanded='true']::before {
  transform: rotate(90deg);
}

.btn-toggle-nav a {
  display: inline-flex;
  padding: 0.1875rem 0.5rem;
  margin-top: 0.125rem;
  margin-left: 1.25rem;
  text-decoration: none;
}

.btn-toggle-nav a:hover,
.btn-toggle-nav a:focus {
  background-color: #d2f4ea;
}

.scrollarea {
  overflow-y: auto;
}

.fw-semibold {
  font-weight: 600;
}

.lh-tight {
  line-height: 1.25;
}

.active {
  background-color: #0d6efd;
  border-radius: 0.25rem;
}

.canCLick {
  cursor: pointer;
}

.fontSize-13 {
  font-size: 13px;
}

.stateBox {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.topBox {
  height: 70px;
  border-bottom: 1px solid rgb(221, 221, 221);
  box-shadow: 0 0 4px 0 rgb(0 0 0 / 10%), 0 2px 8px 0 rgb(170 182 206 / 20%),
  inset 0 -1px 0 0 hsl(0deg 0% 100% / 20%);
}

.rightContainer {
  height: 100%;
  position: relative;
}

.partyContainer {
  position: absolute;
  top: 70px;
  left: 0;
  padding: 10px;
  border-bottom: 1px solid rgb(221, 221, 221);
  box-shadow: 0 0 4px 0 rgb(0 0 0 / 10%), 0 2px 8px 0 rgb(170 182 206 / 20%), inset 0 -1px 0 0 hsl(0deg 0% 100% / 20%);
  background-color: #fff;
  width: 260px;
  overflow: hidden;
}

.telNum {
  margin-right: 4px;
  padding: 6px 12px;
  width: 220px;
  border-radius: 4px;
  border-color: #0d6efd;
}

.contentBox {
  margin-top: 40vh;
}

.shrink {
  width: 80px !important;
}

.menuBox {
  position: absolute;
  right: 30px;
}

.btn-primary:disabled {
  background-color: #ccc;
  outline: none;
  border: 0;
  box-shadow: none;
}
</style>


<style scoped>
/* 电话条 */
.canCLick {
  cursor: pointer;
}

.statusContent {
  margin-right: 20px;
  width: 220px;
  height: 38px;
  line-height: 38px;
  border-radius: 20px;
  background-color: #0d6efd;
  color: #fff;
  font-weight: 500;
}

.iconBox {
  border: 1px solid #459ae9;
  border-radius: 50%;
  margin-right: 6px;
  width: 36px;
  height: 36px;
  text-align: center;
  line-height: 35px;
  text-align: center;
  vertical-align: middle;
}

.removeRoom {
  color: #459ae9;
  cursor: pointer;
  /* text-decoration: underline; */
}

.dropdown-box {
  padding-right: 20px;
}
</style>